module.exports = __webpack_public_path__ + "static/media/appointment.c7cd4130.svg";